<template>
    <div class="row flex-grow">
        <div class="col-lg-4 mx-auto">
            <div class="auth-form-light text-left pl-5 pr-5 pb-5">
                <div class="brand-logo text-right">
                    <img :src="'/media/aform-logo-black.png'" alt="Coachingclub.lu">
                </div>
                <h4>{{ $t('pages.forgot_password.title') }}</h4>
                <h6 class="font-weight-light" v-html="$t('pages.forgot_password.subtitle')"></h6>
                <form class="pt-3" @submit.prevent="resetPassword">
                    <div class="input-group">
                        <input type="email" id="email" class="form-control form-control-lg" :class="{'is-invalid': $errors.has('email')}" :placeholder="$t('pages.forgot_password.email')" v-model="email">
                        <error input="email"/>
                    </div>
                    <div class="mt-3">
                        <button class="btn btn-block btn-outline-dark btn-lg font-weight-medium auth-form-btn">
                            {{ $t('pages.forgot_password.reset_password') }}
                        </button>
                    </div>
                    <div class="my-2 d-flex justify-content-between align-items-center">
                        <router-link :to="{name: 'login'}" class="auth-link text-black">
                            {{ $t('pages.forgot_password.login') }}
                        </router-link>
                        <span class="font-weight-light">
                            {{ $t('pages.login.dont_have_an_account') }} <a href="register.html" class="text-primary">{{ $t('pages.login.create_account') }}</a>
                        </span>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import AuthRepository from "../../repositories/Auth/AuthRepository";

export default {
    name: "ForgotPassword",
    data: () => ({
        email: ''
    }),
    methods: {
        resetPassword() {
            if(!this.email.length)
                return this.$snotify.error(this.$t('pages.forgot_password.enter_valid_email'));

            AuthRepository
                .requestPasswordResetMail(this.email)
                .then(() => {
                    this.email = '';
                    this.$router.push({name: 'login'});
                })
        }
    }
}
</script>

<style scoped>

</style>
